import { Box, Drawer, Icon, IconButton, Typography } from "@mui/material";
import { TOPBAR_HEIGHT } from "src/styles/layout.js";
import BrowseTree from "./BrowseTree.js";

/**
 * The mobile browse surface: a bottom-anchored drawer holding the nav tree,
 * opened from either the topbar navigation toggle or the bottom tab bar's
 * Browse tab. A distinct drawer instance from the retired left nav — this one
 * slides up and stops below the topbar so the page stays partly visible behind
 * the scrim.
 *
 * @param {{ open: boolean, onClose: () => void }} props
 */
const BrowseSheet = ({ open, onClose }) => (
  <Drawer
    anchor="bottom"
    open={open}
    onClose={onClose}
    data-testid="discovery-sidebar-drawer"
    // Instant exit: navigating unmounts the tree immediately instead of relying
    // on a slide-out that the next page's mount can starve, leaving it stuck open.
    transitionDuration={{ enter: 225, exit: 0 }}
    keepMounted={false}
    sx={{ display: { xs: "block", md: "none" } }}
    PaperProps={{
      sx: {
        top: `${TOPBAR_HEIGHT}px`,
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        maxHeight: `calc(100dvh - ${TOPBAR_HEIGHT}px)`,
      },
    }}
  >
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        px: 2,
        py: 1.5,
        backgroundColor: "paper.primary",
        borderBottom: (theme) => `1px solid ${theme.palette.border.tertiary}`,
      }}
    >
      <Typography variant="h4" sx={{ flex: 1, fontWeight: 700 }}>
        Browse
      </Typography>
      <IconButton onClick={onClose} aria-label="Close browse" edge="end">
        <Icon baseClassName="material-symbols-outlined">close</Icon>
      </IconButton>
    </Box>
    <Box sx={{ px: 1, py: 1, overflowY: "auto" }}>
      <BrowseTree onNavigate={onClose} defaultOpen={["sports"]} surface="browse-sheet" />
    </Box>
  </Drawer>
);

export default BrowseSheet;
